angular.module("vgresiduos").factory("supplierDocumentService", [
	"$http",
	"$q",
	"accountService",
	function ($http, $q, accountService) {
		"use strict";

		function getDisposalDocumentsBaseRequestUrl() {
			return (
				Vgr.constants.suppliersHostUrl +
				Vgr.resources.suppliers.disposalDocuments.replace(
					"[ORGANIZATION]",
					accountService.getCurrentClient().organization.id
				)
			);
		}

		function _calculateDocumentsForDisposalRequest(dto) {
			const req = {
				method: "post",
				url: getDisposalDocumentsBaseRequestUrl(),
				data: {
					organizationUnitCode: accountService.getCurrentClient().code,
					destinatorId: dto.destinatorId,
					residueIds: dto.residueIds
				}
			};

			return $http(req);
		}

		return {
			calculateDocumentsForDisposalRequest: _calculateDocumentsForDisposalRequest
		};
	}
]);
